const SLOT_LABELS = {
  nome:            'Nome',
  queixa:          'Queixa',
  convenio:        'Convênio',
  horario:         'Dia/turno',
  carteirinha:     'Carteirinha',
  fone_confirmado: 'Fone confirmado',
};

export default function SlotPanel({ slots = {}, loading = false }) {
  return (
    <div>
      <p style={{
        fontSize: '11px',
        fontWeight: 600,
        color: '#6C757D',
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        margin: '0 0 10px',
      }}>
        Dados Coletados
      </p>

      {loading ? (
        <p style={{ fontSize: '12px', color: '#ADB5BD' }}>Carregando...</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {Object.keys(SLOT_LABELS).map((key) => {
            const value = slots[key];
            const coletado = value !== null && value !== undefined && value !== '';

            return (
              <div key={key} style={{ display: 'flex', alignItems: 'flex-start', gap: '6px', fontSize: '12px' }}>
                <span style={{ color: coletado ? '#0F6E56' : '#854F0B', flexShrink: 0, lineHeight: '1.4' }}>
                  {coletado ? '✓' : '⏱'}
                </span>
                <div style={{ minWidth: 0 }}>
                  <span style={{ color: '#6C757D' }}>{SLOT_LABELS[key]}: </span>
                  <span style={{ color: coletado ? '#1A1A2E' : '#ADB5BD' }}>
                    {coletado ? value : 'Aguardando'}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
